"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Layout = _interopRequireDefault(require("cornerstone_ui_core/lib/components/Layout"));

var _Button = _interopRequireDefault(require("cornerstone_ui_core/lib/components/Button"));

var _utils = require("cornerstone_ui_core/lib/utils");

var _Menu = _interopRequireDefault(require("../Menu"));

var _lodash = require("lodash");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Sider = _Layout.default.Sider;

var _default = /*#__PURE__*/function (_Component) {
  _inherits(_default, _Component);

  var _super = _createSuper(_default);

  function _default(props) {
    var _this;

    _classCallCheck(this, _default);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "sideNavToggle", function (e) {
      e.preventDefault();

      _this.props.sideNavToggle();
    });

    _defineProperty(_assertThisInitialized(_this), "sideNavHide", function (e) {
      e.preventDefault();

      _this.props.sideNavHide();
    });

    _defineProperty(_assertThisInitialized(_this), "sideNavShow", function (e) {
      e.preventDefault();

      _this.props.sideNavShow();
    });

    _defineProperty(_assertThisInitialized(_this), "onAvatarError", function (e) {
      _this.setState({
        imageSrc: ""
      });
    });

    _this.state = {
      imageSrc: ""
    };

    _this.props.sideNavHide();

    return _this;
  }

  _createClass(_default, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var appName = (0, _utils.getAppName)();

      if (appName && appName === "RDS") {
        //TODO correct applolo gateway to fix
        this.props.getShortcutNavigationOptions();
      }

      var imageString = this.props.profileImage !== "" && this.props.profileImage !== "No Image" ? "data:image/jpg;base64, " + this.props.profileImage : false; // : constructImageUrl(this.props.user.email);
      // this.setState({ imageSrc: imageString });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          isSidenavCollapsed = _this$props.isSidenavCollapsed,
          location = _this$props.location,
          user = _this$props.user,
          menus = _this$props.menus,
          logout = _this$props.logout,
          dept = _this$props.dept;
      var imageString = this.state.imageSrc;
      var userdept;

      if (user && !(0, _lodash.isNil)(user["department"])) {
        userdept = user["department"]["Dept"].slice(1, -1); //userdept = userdept.split(" ");
        //userdept.splice(-1, 1);
        //userdept = userdept.join(" ").replace("-", " ");

        userdept = (0, _lodash.replace)(userdept, /([\d*]())/g, ""); //to replace digits

        userdept = (0, _lodash.replace)(userdept, /[()]/g, ""); //to replace paranthesis

        userdept = (0, _lodash.replace)(userdept, "-", " "); //to replace -

        userdept = (0, _lodash.trim)(userdept); //to remove whitespaces leading to trailing
      } //  Instead of giving margingLeft one fixed side inside one relative sider used here
      //  else changing baselayout props to add marginLeft cause whole component refresh.


      return /*#__PURE__*/_react.default.createElement(Sider, {
        collapsed: isSidenavCollapsed,
        collapsedWidth: 60
      }, /*#__PURE__*/_react.default.createElement(Sider, _defineProperty({
        trigger: /*#__PURE__*/_react.default.createElement(_Button.default, {
          className: isSidenavCollapsed ? "collapse-trigger" : "trigger",
          icon: isSidenavCollapsed ? "double-right" : "double-left",
          onClick: this.sideNavToggle,
          style: {
            backgroundColor: "rgba(239, 239, 239, 0)",
            color: "#fff"
          }
        }),
        className: "trigger" // onMouseEnter={this.sideNavShow}
        // onMouseLeave={this.sideNavHide}
        ,
        collapsible: true,
        collapsedWidth: 60,
        collapsed: isSidenavCollapsed,
        theme: "light"
      }, "className", "baseSider"), /*#__PURE__*/_react.default.createElement("div", {
        className: "sidebar-overlay-dark"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "profile-wrapper"
      }, /*#__PURE__*/_react.default.createElement("div", {
        style: {
          marginTop: "5px"
        }
      })), /*#__PURE__*/_react.default.createElement(_Menu.default, {
        defaultSelectedKeys: ["appstore"],
        selectedKeys: [location.pathname],
        defaultOpenKeys: ["appstore"],
        menus: menus,
        shortcutNavigationMenuOptions: this.props.dbMenus,
        user: this.props.user
      }))));
    }
  }]);

  return _default;
}(_react.Component);

exports.default = _default;